import {apolloClient} from '@/setup/apollo-setup';
import {error} from '@/utils/notification';
import {
  GET_NOTIFICATION_CURRENT_USER,
} from '../../../../queries/modules/notification/notification';

export async function getNotificationCurrentUser(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_NOTIFICATION_CURRENT_USER,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setNotifications', data.getNotificationCurrentUser);
      context.commit('setSuccess', null);
      return data.getNotificationCurrentUser
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}
